import { render, staticRenderFns } from "./ConvertPreorderModal.vue?vue&type=template&id=5f822764"
import script from "./ConvertPreorderModal.vue?vue&type=script&lang=js"
export * from "./ConvertPreorderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports